import React, { Component } from 'react'
import { injectIntl, defineMessages } from 'react-intl'
import Select from 'react-select'

const messages = defineMessages({
    "status_new": {
        id: 'inbox.status_selection.status_new',
        defaultMessage: 'New',
    },
    "status_in_progress": {
        id: 'inbox.status_selection.status_in_progress',
        defaultMessage: 'In progress',
    },
    "status_closed": {
        id: 'inbox.status_selection.status_closed',
        defaultMessage: 'Closed',
    },
})

class ConversationStatusSelect extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            options: [],
            multi: this.props.multi || false,
            recurring: this.props.recurring || false,
            selectedOptions: this.props.value || []
        }
        this.state.options = [
            {
                value: 'new',
                label: this.props.intl.formatMessage(messages["status_new"])
            },
            {
                value: 'in-progress',
                label: this.props.intl.formatMessage(messages["status_in_progress"])
            },
            {
                value: 'closed',
                label: this.props.intl.formatMessage(messages["status_closed"])
            },
        ]
        const defaultCallback = () => { }
        this.name = this.props.name
        this.placeholder = this.props.placeholder
        this.onChange = this.props.onChange || defaultCallback
        this.handleChange = this.handleChange.bind(this)
    }

    handleChange(selectedOption) {
        this.setState({
            selectedOptions: selectedOption
        }, () => {
            if(selectedOption){
                if (this.state.multi === true) {
                    this.onChange(selectedOption.map(option => { return option.value }), selectedOption.map(option => { return option.label }).join(','))
                } else {
                    this.onChange(selectedOption.value, selectedOption.label)
                }
            }else{
                this.onChange("","")
            }
        });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.value !== this.state.selectedOptions) {
            this.setState({
                selectedOptions: nextProps.value || []
            })
        }
    }

    render() {
        return (
            <Select
                name={this.name}
                searchable={false}
                multi={this.state.multi}
                placeholder={this.placeholder}
                value={this.state.selectedOptions}
                onChange={this.handleChange}
                options={this.state.options}
            />
        )
    }
}

export default injectIntl(ConversationStatusSelect)





// WEBPACK FOOTER //
// ./src/inbox/conversationstatusselect.component.jsx